<div bsModal #slideRightModal="bs-modal" class="modal fade slide-right" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-sm">
    <div class="modal-content-wrapper">
      <div class="modal-content bg-contrast-lowest">
        <div class="modal-header">
          <h4>{{'Notificações' | translate}}</h4>
          <button type="button" class="close" [style.top]="'15px'" (click)="slideRightModal?.hide()"
            aria-hidden="true" aria-label="{{'Fechar' | translate}}">
          </button>
        </div>
        <div class="modal-body scrollable no-padding" [perfectScrollbar]="util?.scrollconfig" (psYReachEnd)="loadMore()">
          @if (!loading && !notificationCenterService?.notifications?.length) {
            <div class="container-xs-height full-height">
              <div class="row-xs-height">
                <div class="card-body col-xs-height col-middle text-center">
                  <h5>{{'Você não tem nenhuma notificação até o momento' | translate }}</h5>
                  <br>
                    <button type="button" class="btn btn-default btn-block" (click)="slideRightModal?.hide()">{{'Fechar' |
                    translate}}</button>
                  </div>
                </div>
              </div>
            }
            @if (loading || notificationCenterService?.notifications?.length) {
              <ul class="list-view skeleton-chat m-l-0 b-t b-grey"
                >
                @for (notification of notificationCenterService?.notifications; track notification) {
                  <li class="p-t-10 p-l-10 p-r-10">
                    <a (click)="goToNotificationEntity(notification)">
                      <div class="d-flex card-set-wrapper full-height full-width">
                        @if (notification?.sentBy) {
                          <app-user-display [userObject]="notification?.sentBy" matTooltip="{{notification?.sentBy?.name}}" matTooltipPosition="above" [reaction]="null" [layout]="'onlyPic'">
                          </app-user-display>
                        }
                        <div class="detail-list full-width relative m-l-5">
                          <p>{{util?.removeHtml(notification?.message)}} <span class="hint-text small-text">{{notification?.createdOn |
                          dateAgo}}</span></p>
                        </div>
                      </div>
                    </a>
                  </li>
                }
              </ul>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div bsModal #mdStickUp="bs-modal" class="modal fade stick-up" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header clearfix text-left">
          <button type="button" class="close" (click)="mdStickUp.hide()" aria-hidden="true" aria-label="{{'Fechar' | translate}}">
          </button>
          <h5>{{selectedNotification?.title | translate}}</h5>
        </div>
        <div class="modal-body">
          @if (selectedNotification?.sentBy) {
            <app-user-display [userObject]="selectedNotification?.sentBy" matTooltip="{{selectedNotification?.sentBy?.name}}" matTooltipPosition="above" [reaction]="null">
            </app-user-display>
          }
          <p style="white-space: pre-line;">{{util?.removeHtml(selectedNotification?.message)}} <span class="hint-text small-text">{{selectedNotification?.createdOn |
          dateAgo}}</span></p>
        </div>
      </div>
    </div>
  </div>